// extracted by mini-css-extract-plugin
module.exports = {"form-footer":"EditRequestFromPortalView_form-footer__31bl3"};